export const isSSR = typeof window === 'undefined';
export const isLazyLoadingSupported = !isSSR && !!window.IntersectionObserver;
let imageObserver;
export const getImageObserver = () => {
    if (isLazyLoadingSupported && !imageObserver) {
        imageObserver = new window.IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                var _a, _b;
                const { isIntersecting } = entry;
                if (isIntersecting) {
                    let targets = [entry.target];
                    if (((_b = (_a = entry === null || entry === void 0 ? void 0 : entry.target) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.nodeName) === 'PICTURE') {
                        targets = [
                            ...targets,
                            ...Array.from(entry.target.parentNode.querySelectorAll('source'))
                        ];
                    }
                    targets.forEach((target) => {
                        if (target.dataset.srcset) {
                            target.srcset = target.dataset.srcset; // eslint-disable-line no-param-reassign
                        }
                        if (target.dataset.src) {
                            target.src = target.dataset.src; // eslint-disable-line no-param-reassign
                        }
                    });
                    imageObserver.unobserve(entry.target);
                }
            });
        }, { rootMargin: '10px' });
    }
    return imageObserver;
};
//# sourceMappingURL=imageObserver.js.map